import styled from 'styled-components/macro'

export const AppStyled = styled.div`
  min-height: calc(80vh);
`

export const AppWrapper = styled.div`
  position: absolute;
  width: 100vw;
  height: 80vh;
  will-change: transform, opacity;
`
